/**
 * This file contains functions executed by the host to set, get and remove cookies.
 */

// Importing utility functions for handling cookies
import { getCookie, setCookie, removeCookie } from './cookie-access-methods';

// Constant identifier for connection messages
const connectId = 'sessionAccessId-connected';

// Object containing various methods to handle different types of events
const hostMethods = {

	// Method to handle `get` events
	get( event, data, domain ) {

		// Sending a message back to the source of the event with the cookie value
		event.source.postMessage(
			{
				id: data.id,
				data: getCookie( data.key )
			},
			event.origin // Send the message back to the origin of the event
		);
	},

	// Method to handle `set` events
	set( event, data, domain ) {
		setCookie( data.key, data.value, domain );

		event.source.postMessage(
			{
				id: data.id
			},
			event.origin
		);
	},

	// Method to handle `remove` events
	remove( event, data, domain ) {
		removeCookie( data.key );

		event.source.postMessage(
			{
				id: data.id
			},
			event.origin
		);
	},
	connect( event ) {
		event.source.postMessage(
			{
				id: connectId
			},
			event.origin
		);
	}
};

export default hostMethods;
